export function menuKeyForPath(path: string) {
  if (path.startsWith('/system')) return 'system'
  return 'services'
}
